import { GeneralAttribute } from '@deltager/organizers/admin/modules/events/create-event/model/generalAttribute.model';
import { AttributeType } from '@deltager/organizers/admin/modules/events/create-event/model/attribute-type.enum';
import { BuiltInAttributeType } from '@deltager/organizers/admin/shared/models/built-in-attribute-type.enum';

export class BuiltinAttribute {
  name: string;
  wizardAttributeName: string;
  priority: number;
  active: boolean;
  wizardId: boolean;
  affiliateId: boolean;
  belongsTo: boolean;
  clearField: boolean;
  inUse: boolean;
  locked: boolean;
  showOnReceipt: boolean;
  showInList: boolean;
  type: BuiltInAttributeType;
  width: number;
  uiId: number;
  askOncePerOrder?: boolean;
  copyAnswerToAllParticipants?: boolean;
  changeByAdminOnly?: boolean;
  renderAsYearPicker: boolean;
  showOnInstructorsList: boolean;
  isParticipantEditingEnabled: boolean;

  static transformToBuiltinAttribute(generaAttr: GeneralAttribute) {
    const transformedBuiltinAttribute: BuiltinAttribute = {
      name: generaAttr.name,
      wizardAttributeName: generaAttr.placeholder,
      active: generaAttr.active,
      priority: generaAttr.priority,
      type: generaAttr.systemType,
      wizardId: generaAttr.wizardId,
      affiliateId: generaAttr.affiliateId,
      belongsTo: generaAttr.belongsTo,
      clearField: generaAttr.clearField,
      inUse: generaAttr.mandatory,
      locked: generaAttr.locked,
      showOnReceipt: generaAttr.showOnReceipt,
      showInList: generaAttr.showInList,
      width: generaAttr.width,
      askOncePerOrder: generaAttr.askOncePerOrder,
      copyAnswerToAllParticipants: generaAttr.copyAnswerToAllParticipants,
      changeByAdminOnly: generaAttr.changeByAdminOnly,
      renderAsYearPicker: generaAttr.renderAsYearPicker,
      showOnInstructorsList: generaAttr.showOnInstructorsList,
      isParticipantEditingEnabled: generaAttr.isParticipantEditingEnabled,
      uiId: generaAttr.uiId,
    };

    return transformedBuiltinAttribute;
  }

  static transformToGeneralAttribute(builtInAttribute: BuiltinAttribute): GeneralAttribute {
    let generalAttribute = new GeneralAttribute();
    generalAttribute.name = builtInAttribute.name;
    generalAttribute.placeholder = builtInAttribute.wizardAttributeName;
    generalAttribute.active = builtInAttribute.active;
    generalAttribute.systemType = builtInAttribute.type;
    generalAttribute.priority = builtInAttribute.priority;
    generalAttribute.mandatory = builtInAttribute.inUse;
    generalAttribute.options = [];
    generalAttribute.typeOfAttr = AttributeType.builtinAttribute;
    generalAttribute.askOncePerOrder = builtInAttribute.askOncePerOrder;
    generalAttribute.copyAnswerToAllParticipants = builtInAttribute.copyAnswerToAllParticipants;
    generalAttribute.changeByAdminOnly = builtInAttribute.changeByAdminOnly;
    generalAttribute.renderAsYearPicker = builtInAttribute.renderAsYearPicker;
    generalAttribute.uiId = builtInAttribute.uiId;
    generalAttribute.isBuiltinAttr = true;
    generalAttribute.hasAttributeDependencies = false;
    generalAttribute.disabled = true;
    generalAttribute.wizardId = builtInAttribute.wizardId;
    generalAttribute.affiliateId = builtInAttribute.affiliateId;
    generalAttribute.belongsTo = builtInAttribute.belongsTo;
    generalAttribute.clearField = builtInAttribute.clearField;
    generalAttribute.locked = builtInAttribute.locked;
    generalAttribute.showOnReceipt = builtInAttribute.showOnReceipt;
    generalAttribute.showInList = builtInAttribute.showInList;
    generalAttribute.width = builtInAttribute.width;
    generalAttribute.dependencies = [];
    generalAttribute.description = '';
    generalAttribute.showOnInstructorsList = builtInAttribute.showOnInstructorsList;
    generalAttribute.isParticipantEditingEnabled = builtInAttribute.isParticipantEditingEnabled;

    return generalAttribute;
  }
}
